import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { format } from 'date-fns';
import { DateFormat } from '@common/const/date';
// eslint-disable-next-line import/no-duplicates
import { ru } from 'date-fns/locale';

export const usePublishedAt = (data: CatalogItemViewModel) => {
  return format(new Date(data.createdAt), DateFormat.CatalogItemDateThisYear, { locale: ru });
};
